import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../lib/translations';

export function MagicLogin() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const { refreshAuth } = useAuth();
  const { language } = useLanguage();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [memberName, setMemberName] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setError('Invalid magic link');
      return;
    }

    const doLogin = async () => {
      try {
        const result = await api.magicLogin(token);
        setMemberName(result.member.name);
        setStatus('success');

        // Refresh auth context
        await refreshAuth();

        // Redirect after a short delay
        setTimeout(() => {
          navigate('/dashboard');
        }, 2000);
      } catch (err: any) {
        setStatus('error');
        setError(err.message || 'This magic link is invalid or has expired');
      }
    };

    doLogin();
  }, [token, navigate, refreshAuth]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f5f3ff 0%, #ede9fe 50%, #ddd6fe 100%)',
      padding: '1rem'
    }}>
      <div className="card" style={{ maxWidth: '400px', width: '100%', textAlign: 'center' }}>
        {status === 'loading' && (
          <>
            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>✨</div>
            <h1 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>{t('loggingIn', language)}</h1>
            <p style={{ color: '#6b7280' }}>{t('pleaseWait', language)}</p>
            <div style={{ marginTop: '1.5rem' }}>
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600 mx-auto"></div>
            </div>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🎉</div>
            <h1 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>
              {t('welcome', language)}, {memberName}!
            </h1>
            <p style={{ color: '#6b7280' }}>{t('takingToAffirmations', language)}</p>
            <div style={{ marginTop: '1.5rem' }}>
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600 mx-auto"></div>
            </div>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>😕</div>
            <h1 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>{t('oops', language)}</h1>
            <p style={{ color: '#ef4444', marginBottom: '1.5rem' }}>{error}</p>
            <p style={{ color: '#6b7280', marginBottom: '1.5rem' }}>
              {t('askParent', language)}
            </p>
            <button
              className="btn btn-primary"
              onClick={() => navigate('/login')}
            >
              {t('goToLogin', language)}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
